import { PostUpSellVarient } from './PostUpsellVarient';
import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import {
  paddingFields,
  PaddingProps,
} from '../../../../page-builder/puck/reusable-props/padding';

import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../../services/constants';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import {
  ImageProps,
  imageProps,
} from '../../../puck/reusable-props/image-props';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import { JustifyOptions } from '../../../utils/constants';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';

export type SingleProductProps = {
  border: IBorderValueProps;
  justifyContent: string;
  imageBorder: IBorderValueProps;
} & MarginProps &
  PaddingProps &
  ImageProps &
  showComponentProps;

export const SingleProduct = ({
  useAppSelector,
}: ReduxSelectorProps &
  ReduxDispatchProps): ComponentConfig<SingleProductProps> => {
  return {
    label: (
      <CustomTooltip title="Product">
        <span>Single Product</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      justifyContent: {
        type: 'select',
        label: 'Justify-Content',
        options: JustifyOptions,
      },
      ...imageProps([]),
      imageBorder: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Image Border" />
        ),
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...borderProps,
      image: {
        height: {
          desktop: '100%',
          mobile: '100%',
          tablet: '100%',
        },
        maxWidth: {
          desktop: '100%',
          mobile: '100%',
          tablet: '100%',
        },
        deviceType: 'desktop',
      },
      imageBorder: {
        deviceType: 'desktop',
        borderBottomLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderBottomRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopWidth: {
          desktop: 0,
          tablet: 0,
          mobile: 0,
        },
        borderRightWidth: {
          desktop: 0,
          tablet: 0,
          mobile: 0,
        },
        borderBottomWidth: {
          desktop: 0,
          tablet: 0,
          mobile: 0,
        },
        borderLeftWidth: {
          desktop: 0,
          tablet: 0,
          mobile: 0,
        },
        borderWidth: {
          desktop: 0,
          tablet: 0,
          mobile: 0,
        },
        borderStyle: {
          desktop: 'border-solid',
          tablet: 'border-solid',
          mobile: 'border-solid',
        },
        borderColor: {
          desktop: '#000000',
          tablet: '#000000',
          mobile: '#000000',
        },
      },
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      justifyContent: 'justify-center',
    },
    render: ({
      margin,
      padding,
      justifyContent,
      editMode,
      image,
      border,
      imageBorder,
      showComponent,
    }) => {
      const postUpsell = useAppSelector(state => state.postUpSell);
      const postUpsellState = useAppSelector(state => state.postUpSellState);
      const postUpSellRecommendation = postUpsell.postUpsellData;
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const currentUpsellData = postUpsell?.currentUpsellData;

      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const currentRecommendation =
        postUpSellRecommendation?.[postUpsellState?.currentIndex];

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType),
              }}
              className={`flex  w-full h-full ${justifyContent} ${border?.borderStyle?.[currentDeviceType]} `}>
              <PostUpSellVarient
                currentRecommendation={currentRecommendation}
                selectedVarient={postUpsell?.selectedVariantForSingleProduct}
                height={image?.height}
                maxWidth={image?.maxWidth}
                currentDeviceType={currentDeviceType}
                imageBorder={imageBorder}
                currentUpsellData={currentUpsellData}
              />
            </div>
          )}
        </>
      );
    },
  };
};
